export var SuggestionItemStyles = function (props) {
    return {
        closeButton: {
            background: 'transparent',
        },
    };
};
export var SuggestionsStyles = function (props) {
    return {
        suggestionsContainer: {
            borderBottom: 'none',
        },
    };
};
//# sourceMappingURL=PickerSuggestions.styles.js.map